export const GET_LESSON_HISTORY_SUCCESS = 'GET_LESSON_HISTORY_SUCCESS';
export const GET_LESSON_HISTORY = 'GET_LESSON_HISTORY';
